import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

async function cleanLocalServiceWorker(): Promise<void> {
  if (environment.environmentName !== 'LOCAL') {
    return;
  }

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();

    await Promise.all(
      registrations.map((registration) => registration.unregister()),
    );
  }

  if ('caches' in window) {
    const cacheNames = await caches.keys();

    await Promise.all(
      cacheNames
        .filter((name) => name.startsWith('ngsw:'))
        .map((name) => caches.delete(name)),
    );
  }
}

cleanLocalServiceWorker()
  .catch((error) => console.warn('Nettoyage du Service Worker local impossible', error))
  .finally(() => {
    bootstrapApplication(App, appConfig)
      .catch((error) => console.error(error));
  });